import { render, staticRenderFns } from "./DocumentSettings.vue?vue&type=template&id=2ce87700&"
import script from "./DocumentSettings.vue?vue&type=script&lang=js&"
export * from "./DocumentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports